/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function(){
  

 
});

$('.pump-banner-slide').slick({
  dots:false,
  infinite: true,
  speed: 500,
  fade: true,
  autoplay: true,
  autoplaySpeed: 4000,
  slidesToShow: 1
 
});
$('.spas-banner-slide').slick({
  dots:false,
  arrows:true,
  infinite: true,
  speed: 500,
  fade: true,
  autoplay: true,
  autoplaySpeed: 4000,
  slidesToShow: 1,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        dots:true,
        
        arrows:false
      }
    }
  ]
 
});

$('.need-pump-banner').slick({
  dots:true,
  infinite: true,
  speed: 500,
  arrows:false,
  fade: false,
  autoplay: true,
  autoplaySpeed: 4000,
  slidesToShow: 1
 
});
$('.energy-speed-pump').slick({
  dots:true,
  infinite: true,
  speed: 500,
  fade: true,
  arrows:false,
  autoplay: true,
  autoplaySpeed: 4000,
  slidesToShow: 1
 
});
$('.single-two-pumps').slick({
  dots:true,
  infinite: true,
  speed: 500,
  fade: true,
  arrows:false,
  autoplay: true,
  autoplaySpeed: 4000,
  slidesToShow: 1
 
});
$('.booster-pumps').slick({
  dots:true,
  infinite: true,
  speed: 500,
  fade: true,
  arrows:false,
  autoplay: true,
  autoplaySpeed: 4000,
  slidesToShow: 1
 
});
$('.filter_banner').slick({
  dots:false,
  infinite: true,
  speed: 500,
  fade: true,
  autoplay: true,
  autoplaySpeed: 4000,
  slidesToShow: 1,
   responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        dots:true,
        
        arrows:false
      }
    }
  ]
 
});
$('.choose-filter').slick({
  dots:true,
  infinite: true,
  speed: 500,
  fade: true,
  arrows:false,
  autoplay: true,
  autoplaySpeed: 4000,
  slidesToShow: 1
 
});
$('.hayward-filter').slick({
  dots:true,
  infinite: true,
  speed: 500,
  fade: true,
  arrows:false,
  autoplay: true,
  autoplaySpeed: 4000,
  slidesToShow: 1
 
});
$('.Hayward-Cartridge-Filters').slick({
  dots:true,
  infinite: true,
  speed: 500,
  fade: true,
  arrows:false,
  autoplay: true,
  autoplaySpeed: 4000,
  slidesToShow: 1
 
});
$('.Hayward-Sand-Filters').slick({
  dots:true,
  infinite: true,
  speed: 500,
  fade: true,
  arrows:false,
  autoplay: true,
  autoplaySpeed: 4000,
  slidesToShow: 1
 });






$('.heaters_banner').slick({
  dots:false,
  infinite: true,
  speed: 500,
  fade: true,
  autoplay: true,
  autoplaySpeed: 4000,
  slidesToShow: 1,
   responsive: [
    {
      breakpoint: 600,
      settings: {
        dots:true,
        slidesToShow: 1,
        arrows:false
      }
    }
  ]
 
});
$('.Heat-Pump-Pool-Heat').slick({
  dots:true,
  infinite: true,
  speed: 500,
  fade: true,
  arrows:false,
  autoplay: true,
  autoplaySpeed: 4000,
  slidesToShow: 1
 
});
$('.Best-Heat-Solution').slick({
  dots:true,
  infinite: true,
  speed: 500,
  fade: true,
  arrows:false,
  autoplay: true,
  autoplaySpeed: 4000,
  slidesToShow: 1
 
});
$(document).ready(function(){
     $('#crcle-heading').circleType({radius:135});
});
$(document).ready(function() {
  //toggle the component with class accordion_body
  $(".accordion_head").click(function() {
    if ($('.all_fabric_color_show .accordion_body').is(':visible')) {
      $(".all_fabric_color_show .accordion_body").slideUp(300);
      $(".fabric_color .plusminus").text('+');
    }
    if ($(".all_fabric_color_show .accordion_body").is(':visible')) {
      $(".all_fabric_color_show .accordion_body").slideUp(300);
      $(".fabric_color .plusminus").text('+');
    } else {
      $(".all_fabric_color_show .accordion_body").slideDown(300);
      $(".fabric_color .plusminus").text('-');
    }
  });
  $('.product-block-list__item--description a').each(function(){
    var getfilename = $(this).attr('href');
var getfiletype = getfilename.replace(/^.*\./, '.');
    var filetypepdf = getfiletype.slice(0, 4);

    if(filetypepdf == '.pdf'){
      $(this).addClass('product_pdf_link_ns');
      $(this).parents('.product-block-list__item--description').siblings('.manuals-attachments-tab').addClass('show-manuals-attachments-tab')
      var getpdfdata = $(this).html();
      var pdficon = $('<span class="img_icon"><img src="https://cdn.shopify.com/s/files/1/0426/5373/files/pdf-icon.png?v=1595394615"></span>')
      var addpdfhtml = $('<span class="add_pdf_link"><a href='+getfilename+' target="_blank">'+getpdfdata+'</a></span><br>');
      
      $('.pdf-file-link').append(pdficon,addpdfhtml);
    }
    else{
   
    }
  });
  $(".all_fabric_color_box li").slice(0, 18).show();
        $("body").on('click touchstart', '.load-more', function (e) {
            e.preventDefault();
            $(".all_fabric_color_box li:hidden").slice(0, 18).slideDown();
            if ($(".all_fabric_color_box li:hidden").length == 0) {
                $(".load-more").css('visibility', 'hidden');
            }
           
        });
   $(".all_fabric_color_box .fab_c_img").click(function () {
        $(this).siblings(".fabe_img_show").show();
    });
    
    $(".close_btn, .overlay").click(function () {
        $(".fabe_img_show").hide();
    });
});

